import DateHelper from '../../../Utility/DateHelper';
import { Random } from '../../../Utility/Random';
import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setCoins, setLives } from '../PlayerInventoryHelper';
import { updateFoxTimer } from '../PlayerTimerHelper';

export function receiveFoxReward(state: IGameState): IGameState {
    if (
        !DateHelper.isTimeUp(
            state.playerState.foxTimer,
            DateHelper.hoursToMilliseconds(12)
        )
    ) {
        return state;
    }

    let playerState = state.playerState;
    const reward: number = Random.int(0, 2);
    if (reward === 0) {
        playerState = setCoins(playerState, playerState.coins + 50);
    } else if (reward === 1) {
        playerState = setCoins(playerState, playerState.coins + 75);
    } else {
        playerState = setLives(playerState, playerState.lives + 1);
    }

    playerState = { ...playerState, foxTimer: null };

    playerState = updateFoxTimer(playerState);

    trackTransaction(state, TransactionType.REWARD, TActionType.REWARD);

    return {
        ...state,
        playerState,
    };
}
